import { Ticket } from "./Entity";
import { PagedList } from "./PagedList";

export class VariableIncome extends Ticket {
  constructor() {
    super();
  }

  id: number = null;
  operationDate: Date = null;
  settlementDate: Date = null;
  stockExchangeDate: Date = null;
  clientCode: string = null;
  clientCodeDigit: string = null;
  brokerCode: string = null;
  items: VariableIncomeRowItem[] = null;
  pagedResultItems: PagedList<VariableIncomeRowItem> = null;
  buyTotal: number = null;
  sellTotal: number = null;

  deleted?: number[];
}

export class VariableIncomeRowItem {
  id: number = null;
  marketType: string = null;
  buySell: string = null;
  tradingCode: string = null;
  companyName: string = null;
  specification: string = null;
  amount: number = null;
  price: number = null;

  newItem = false;
}
